import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { store } from '../../configureStore';
import orm from '../../orm';
import getIcon from '../content/map/iconUtils/SelectedFontAwesome';
// import { navNodeExperienceIdSelector, navNodeIdSelector } from './selectors';
import { useState } from 'react';
import SharingProviders from '../sharing/SharingProviders';

// import '../../App.css';

const DEBUG = true;
const debugLog = (msg: string) => {
  if (DEBUG) {
    console.log(msg);
  }
};

type Props = {
  navNodeId: string;
  // experienceId: string;
  showBrandNameSettings: boolean;
  showGoBack: boolean;
  showSettings: boolean;
  showSharing: boolean;
  title: string;
};

const NavBarComponent = (props: Props): any => {
  debugLog('Component: NavBarComponent with props: ' + JSON.stringify(props, null, 2));

  const navigate = useNavigate();

  const session = orm.session(store.getState().orm);
  const { Experience, Map, NavNode } = session;

  const navNodeId = props.navNodeId;
  debugLog('B1 : navNodeId: ' + navNodeId);

  // @ts-ignore
  const navNode = NavNode.withId(navNodeId);

  let tmpExperienceId: string = navNode?.experienceId;

  // @ts-ignore
  let tmpExperience = Experience.withId(tmpExperienceId);

  if (tmpExperienceId == null || tmpExperienceId == undefined || tmpExperienceId == "undefined" || tmpExperienceId == "") {
    if (session.Experience.all().toRefArray().length > 0) {
      const tmpExperience = session.Experience.all().toRefArray()[0];
      // @ts-ignore
      tmpExperienceId = tmpExperience.id;
    }
  }

  const currentExperience = tmpExperience;


  const aboutNavNodeId: string = currentExperience?.aboutNavNodeId;
  debugLog('NavBarComponent abutNavNodeId: ' + JSON.stringify(aboutNavNodeId, null, 2));

  const acknowledgementsNavNodeId: string = currentExperience?.acknowledgementsNavNodeId;
  debugLog('NavBarComponent acknowledgementsNavNodeId: ' + JSON.stringify(acknowledgementsNavNodeId, null, 2));

  // const homePageURL = `${process.env.REACT_APP_BASENAME}/index.html`;
  // debugLog('NavBarComponent homePageURL: ' + JSON.stringify(homePageURL, null, 2));

  const rootNaNodeId = currentExperience?.rootNavNodeId;
  const homePageURL = `${process.env.REACT_APP_BASENAME}/#nn=${rootNaNodeId}`;
  debugLog('NavBarComponent homePageURL: ' + JSON.stringify(homePageURL, null, 2));

  const helpNavNodeId: string = currentExperience?.helpNavNodeId;
  debugLog('NavBarComponent helpNavNodeId: ' + JSON.stringify(helpNavNodeId, null, 2));

  const mapNavNodeId: string = currentExperience?.mapNavNodeId;
  debugLog('NavBarComponent mapNavNodeId: ' + JSON.stringify(mapNavNodeId, null, 2));
  const mapPageURL = `${process.env.REACT_APP_BASENAME}/#nn=${mapNavNodeId}`;
  debugLog('NavBarComponent mapPageURL: ' + JSON.stringify(mapPageURL, null, 2));

  const showWebNavigationBar: boolean = currentExperience?.showWebNavigationBar;
  debugLog('NavBarComponent showWebNavigationBar: ' + JSON.stringify(showWebNavigationBar, null, 2));

  const webAboutNavNodeId: string = currentExperience?.webAboutNavNodeId;
  debugLog('NavBarComponent webAboutNavNodeId: ' + JSON.stringify(webAboutNavNodeId, null, 2));

  const webHelpNavNodeId: string = currentExperience?.webHelpNavNodeId;
  debugLog('NavBarComponent webHelpNavNodeId: ' + JSON.stringify(webHelpNavNodeId, null, 2));

  const webReleaseUrl: string = currentExperience?.webReleaseUrl;
  debugLog('NavBarComponent webReleaseUrl: ' + JSON.stringify(webReleaseUrl, null, 2));




  const handleSelect = (eventKey: any) => {
    // alert(`selected ${eventKey}`);
    debugLog(`selected ${eventKey}`);
    switch (eventKey) {
      case 'GO-BACK':
        debugLog('B8 : NavBarComponent GO-BACK');
        navigate(-1);
        break;
      case 'HOME':
        debugLog('B9 : NavBarComponent HOME');
        // navigate(homePageURL, { replace: true });
        navigate(homePageURL);
        break;
      case 'MAP':
        debugLog('B11 : NavBarComponent mapPageURL: ' + mapPageURL);
        debugLog('B12 : NavBarComponent MAP');
        navigate(mapPageURL);
        break;
      case 'HELP':
        debugLog('helpNavNodeId: ' + helpNavNodeId);
        const helpPageURL = `${process.env.REACT_APP_BASENAME}/#nn=${helpNavNodeId}`;
        debugLog('helpPageURL: ' + helpPageURL);
        navigate(helpPageURL);
        break;
      case 'SHARE':
        // navigate('/share', { state: { url: 'https://google.com', title: 'My Title' } });
        setShow(true);
        break;
      case 'ABOUT':
        debugLog('aboutNavNodeId: ' + aboutNavNodeId);
        const aboutPageURL = `${process.env.REACT_APP_BASENAME}/#nn=${aboutNavNodeId}`;
        debugLog('aboutPageURL: ' + aboutPageURL);
        navigate(aboutPageURL);
        break;
      case 'ACKNOWLEDGEMENTS':
        debugLog('acknowledgementsNavNodeId: ' + acknowledgementsNavNodeId);
        const acknowledgementsPageURL = `${process.env.REACT_APP_BASENAME}/#nn=${acknowledgementsNavNodeId}`;
        navigate(acknowledgementsPageURL);
        debugLog('acknowledgementsPageURL: ' + acknowledgementsPageURL);
        break;
      default:
        // navigate(homePageURL, { replace: true });
        navigate(homePageURL);
        break;
    }
  };

  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);

  const handleClose = () => {
    setShow(false);
  };

  const iconSize = Math.round(30 * 1.3);

  return (
    <>

      <Modal
        show={show}
        // onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        {/* <Modal.Header closeButton> */}
        <Modal.Header >
          <Modal.Title>Share With Friends</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <SharingProviders />

        </Modal.Body>
        {/* <Modal.Body> END */}
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {/* <Button variant="primary">Understood</Button> */}
        </Modal.Footer>
      </Modal >



      <Navbar
        sticky={'top'}
        // fixed={'top'}
        // onSelect={handleSelect}
        // collapseOnSelect
        expand={true}
        // expanded="expanded"
        // className="bg-body-tertiary"
        style={{
          backgroundColor: `rgba(30, 70, 69, 1.0)`,
          position: 'static',
          // height: constants.NAVBAR_HEIGHT * window.innerHeight,
          // top: 0,
          // height: constants.NAVBAR_HEIGHT,
          // height: '7vh',
          // borderStyle: 'solid',
          // borderColor: `rgba(0, 255, 0, 1.0)`,
          // borderWidth: 1,
        }}
      >

        <Nav className=" " onSelect={handleSelect} style={{
          // height: constants.NAVBAR_HEIGHT,
          // display: 'flex',
          // height: '7vh',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          // borderStyle: 'solid',
          // borderColor: `rgba(0, 0, 255, 1.0)`,
          // borderWidth: 1,
        }}>

          <div className='d-flex ' style={{
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            // height: '7vh',
            // width: '30%',
            // borderStyle: 'solid',
            // borderColor: `rgba(190, 100, 100, 1.0)`,
            // borderWidth: 1,
          }}>


            <Nav.Link className="d-flex px-3 px-md-4 " eventKey="GO-BACK" style={{
            }} >
              <FontAwesomeIcon
                style={{
                  position: 'relative',
                  color: `rgba(255, 255, 255, 1.0)`,
                  backgroundColor: `rgba(73, 112, 104, 0.0)`,
                  boxShadow: 'none',
                  // width: 54,
                  width: iconSize,
                  height: iconSize,
                  // borderStyle: 'solid',
                  // borderColor: `rgba(0, 255, 255, 1.0)`,
                  // borderWidth: 1,
                }}
                icon={getIcon('fa-regular fa-chevron-left')}
              />
            </Nav.Link>

            <Nav.Link className="d-flex px-3 px-md-4  " eventKey="MAP" style={{
              // borderStyle: 'solid',
              // borderColor: `rgba(255, 255, 0, 1.0)`,
              // borderWidth: 5,
            }} >
              <FontAwesomeIcon
                style={{
                  position: 'relative',
                  color: `rgba(255, 255, 255, 1.0)`,
                  backgroundColor: `rgba(73, 112, 104, 0.0)`,
                  boxShadow: 'none',
                  width: iconSize,
                  height: iconSize,
                  // borderStyle: 'solid',
                  // borderColor: `rgba(0, 255, 255, 1.0)`,
                  // borderWidth: 5,
                }}
                icon={getIcon('fa-regular fa-map-location-dot')}
              />
            </Nav.Link>


            <Nav.Link className="d-flex px-3 px-md-4  " eventKey="HOME" style={{
              // borderStyle: 'solid',
              // borderColor: `rgba(255, 255, 0, 1.0)`,
              // borderWidth: 5,
            }} >
              <FontAwesomeIcon
                style={{
                  position: 'relative',
                  color: `rgba(255, 255, 255, 1.0)`,
                  backgroundColor: `rgba(73, 112, 104, 0.0)`,
                  boxShadow: 'none',
                  width: iconSize,
                  height: iconSize,
                  // borderStyle: 'solid',
                  // borderColor: `rgba(0, 255, 255, 1.0)`,
                  // borderWidth: 5,
                }}
                icon={getIcon('fa-regular fa-house-blank')}
              />
            </Nav.Link>
          </div>

          <div className=' d-flex' style={{
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            // height: '7vh',
            // width: '20%',
            // borderStyle: 'solid',
            // borderColor: `rgba(255, 0, 0, 1.0)`,
            // borderWidth: 1,

          }}>

            <Nav.Link className="d-flex px-3 px-md-4  " eventKey="SHARE" >
              <FontAwesomeIcon
                style={{
                  position: 'relative',
                  color: `rgba(255, 255, 255, 1.0)`,
                  backgroundColor: `rgba(73, 112, 104, 0.0)`,
                  boxShadow: 'none',
                  width: iconSize,
                  height: iconSize,
                }}
                icon={getIcon('fa-regular fa-share')}
              />
            </Nav.Link>

            {/* </Nav> */}

            {/* */}
            {(helpNavNodeId != null || aboutNavNodeId != null || acknowledgementsNavNodeId != null) &&

              <NavDropdown
                className="d-flex px-3 px-md-4 justify-content-center align-items-center "
                align="end"
                style={{
                  color: `rgba(255, 255, 255, 1.0)`,
                  // zIndex:50000000,
                  // borderStyle: 'solid',
                  // borderColor: `rgba(255, 255, 0, 1.0)`,
                  // borderWidth: 5,
                }}
                title={<FontAwesomeIcon
                  style={{
                    position: 'relative',
                    color: `rgba(255, 255, 255, 1.0)`,
                    backgroundColor: `rgba(73, 112, 104, 0.0)`,
                    boxShadow: 'none',
                    width: iconSize,
                    height: iconSize,
                    paddingTop: '5px',
                    // borderStyle: 'solid',
                    // borderColor: `rgba(55, 55, 55, 1.0)`,
                    // borderWidth: 5,
                  }}
                  icon={getIcon('fa-regular fa-bars')}
                />
                }
                id="collapsible-nav-dropdown"
              >

                {webHelpNavNodeId != null &&
                  <NavDropdown.Item eventKey="HELP">Help</NavDropdown.Item>
                }

                {webAboutNavNodeId != null &&
                  <NavDropdown.Item eventKey="ABOUT">About</NavDropdown.Item>
                }

                {acknowledgementsNavNodeId != null &&
                  <NavDropdown.Item eventKey="ACKNOWLEDGEMENTS"> Acknowledgements </NavDropdown.Item>
                }
              </NavDropdown>
            }
            {/* */}

          </div>
        </Nav>
      </Navbar >

    </>

  )
};

export default NavBarComponent;
